import React from "react";

import { useTranslation } from "react-i18next";

import { useFormContext, Controller } from "react-hook-form";

import { DropdownDevise, InputGroup } from "@components/tailwindComponents";

import { formatToNumber } from "@helpers/_functions";

export default function InputAnnualAdvantage({
  readOnly = false,
  index = 0,
  deviseList = []
}) {
  const { control } = useFormContext();
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);

  return (
    <div className="arh-mb-3">
      <div className="arh-relative arh-flex arh-w-full">
        <Controller
          control={control}
          name={`AdvantageType.${index}.annualValue`}
          render={({
            field: { onChange, name, value },
            fieldState: { invalid }
          }) => (
            <InputGroup
              name={name}
              onChange={(event) => {
                const nextValue = formatToNumber(event.target.value);
                onChange(nextValue);
              }}
              value={value}
              invalid={invalid}
              disabled={readOnly}
              placeholder={translate("Valeur annuelle")}
              label={translate("Valeur annuelle")}
              classParent="arh-w-full"
              classContent="arh-w-24"
              content={
                <DropdownDevise
                  control={control}
                  name={`AdvantageType.${index}.annualDevise`}
                  defaultValue={deviseList[0] || {}}
                  disable={readOnly}
                  rules={{ required: true }}
                />
              }
            />
          )}
        />
      </div>
    </div>
  );
}
